module.exports = __webpack_public_path__ + "img/img21.cd38a006.png";